/**
 * 「我的模板」横向缩略条：一进来就看见自己有哪几套版式、长什么样，点一下切换。
 * 以前只有一个下拉，名字之外什么都看不到。
 */
import type { FieldMeta } from '../../api/types';
import type { ContractTemplate } from '../../contract/types';
import { TemplateThumb } from './TemplateThumb';

interface Props {
  templates: ContractTemplate[];
  selectedId: string | null;
  fieldMetas: FieldMeta[];
  onSelect: (id: string) => void;
}

export function MyTemplatesStrip({ templates, selectedId, fieldMetas, onSelect }: Props) {
  return (
    <div style={{ marginBottom: 10 }}>
      <div className="pp-panel-title">我的模板 · {templates.length}</div>
      <div className="pp-scroll" style={{ display: 'flex', gap: 8, overflowX: 'auto', paddingBottom: 4 }}>
        {templates.map((t) => {
          const on = t.id === selectedId;
          return (
            <button
              key={t.id}
              className="pp-bare-button"
              onClick={() => onSelect(t.id)}
              title={t.name}
              style={{
                flex: '0 0 132px',
                border: on ? '2px solid var(--accent)' : '1px solid var(--border-soft)',
                borderRadius: 8,
                overflow: 'hidden',
                background: 'var(--surface-1)',
              }}
            >
              <TemplateThumb template={t} fieldMetas={fieldMetas} height={72} badge={t.shared ? '团队' : null} />
              <div
                style={{
                  padding: '5px 8px',
                  fontSize: 11.5,
                  fontWeight: on ? 700 : 500,
                  color: on ? 'var(--accent)' : 'var(--ink-2)',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }}
              >
                {t.name}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}
